module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Date From:")]), _vm._v(" "), _c('date-picker', {
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "lang": "en"
    },
    model: {
      value: (_vm.objRfcFilters.startDate),
      callback: function($$v) {
        _vm.$set(_vm.objRfcFilters, "startDate", $$v)
      },
      expression: "objRfcFilters.startDate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Date To:")]), _vm._v(" "), _c('date-picker', {
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "lang": "en"
    },
    model: {
      value: (_vm.objRfcFilters.endDate),
      callback: function($$v) {
        _vm.$set(_vm.objRfcFilters, "endDate", $$v)
      },
      expression: "objRfcFilters.endDate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Originator:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.rfcOriginators,
      "item-value": "id",
      "label": "Select Originator",
      "autocomplete": "",
      "solo": ""
    },
    model: {
      value: (_vm.objRfcFilters.originator),
      callback: function($$v) {
        _vm.$set(_vm.objRfcFilters, "originator", $$v)
      },
      expression: "objRfcFilters.originator"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Customer:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.rfcCustomers,
      "item-value": "id",
      "label": "Select Customer",
      "autocomplete": "",
      "solo": ""
    },
    model: {
      value: (_vm.objRfcFilters.customer),
      callback: function($$v) {
        _vm.$set(_vm.objRfcFilters, "customer", $$v)
      },
      expression: "objRfcFilters.customer"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.rfcStatusses,
      "item-value": "id",
      "label": "Select Status",
      "autocomplete": "",
      "solo": ""
    },
    model: {
      value: (_vm.objRfcFilters.status),
      callback: function($$v) {
        _vm.$set(_vm.objRfcFilters, "status", $$v)
      },
      expression: "objRfcFilters.status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("SR Number:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Sr Number",
      "solo": ""
    },
    model: {
      value: (_vm.objRfcFilters.srNumber),
      callback: function($$v) {
        _vm.$set(_vm.objRfcFilters, "srNumber", $$v)
      },
      expression: "objRfcFilters.srNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("CN Number:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "CN Number",
      "solo": ""
    },
    model: {
      value: (_vm.objRfcFilters.cnNumber),
      callback: function($$v) {
        _vm.$set(_vm.objRfcFilters, "cnNumber", $$v)
      },
      expression: "objRfcFilters.cnNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("RFC Number:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "RFC Number",
      "solo": ""
    },
    model: {
      value: (_vm.objRfcFilters.rfcNumber),
      callback: function($$v) {
        _vm.$set(_vm.objRfcFilters, "rfcNumber", $$v)
      },
      expression: "objRfcFilters.rfcNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncClearFilters()
      }
    }
  }, [_vm._v("Clear Filters")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncGenerateRfcReport()
      }
    }
  }, [_vm._v("Generate")])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "requiredMessage",
    attrs: {
      "lg12": ""
    }
  }, [_vm._v("\n\t\t\t \n\t\t")])], 1)], 1)
},staticRenderFns: []}